import { TextEllipsis } from './text-ellipsis';

export {
    TextEllipsis
}